export interface StylePaneable {
  id: string;
  parentId: string;
}

/** Identifies the Style Pane as the `sourceComponent` on `requestExternalDataRefresh` payloads.
 * Used both when the pane emits (so host views redecorate) and in the pane's own receiving epic
 * (so `isNotSameExternalDataRefreshRequest` filters out the pane's own edits and it doesn't
 * redecorate itself). Both sides must use this same value.
 */
export const STYLE_PANE_COMPONENT = 'StylePane';

/** Supported hardcoded `StylePane` modeldefn ids
 * These are the only two supported, as support for a second
 * defnId was glued on when Assortment Build was added
 * when dinosaurs walked the earth
 */
export const enum StylePaneDefnIds {
  HistoryStyleReview = 'HistoryStyleReview',
  StyleChannelReview = 'StyleChannelReview',
}

/** Ancient hardcoding */
export const stylePaneHardcodedAggBys = ['level:channel', 'level:stylecolor'];

/** These are also ancient hardcoding that has always existed
 * Exported here so it can remain consistent
 */
export const getStylePaneViewDefnId = (isAssortmentBuild: boolean) =>
  isAssortmentBuild ? 'AssortmentStyleDetailsPane' : 'HistoryStylePaneLayout';
export const getStylePaneDefnId = (isAssortmentBuild: boolean) =>
  isAssortmentBuild ? StylePaneDefnIds.StyleChannelReview : StylePaneDefnIds.HistoryStyleReview;
